__turbopack_context__.v({
  "bgBlur": "CenteredLoaderWithBlur-module-scss-module__gCHf5G__bgBlur",
});
